<template>
  <div>
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center ht-70">
            <i class="icon fa fa-globe" style="font-size: 56px"></i>
            <div class="mg-l-20">
              <h4>{{ $t("express.海外物流管理") }}</h4>
            </div>
          </div>
          <div class="tx-right"></div>
        </div>
      </div>
      <div class="card mg-x-50 pd-20 mg-t-10 card-subuser">
        <div class="row form-group">
          <label class="wd-150 col-form-label form-control-sm text-right">
            {{ $t("express.物流名称：") }}<span class="tx-danger">*</span>
          </label>
          <div class="col-6">
            <input
              class="form-control form-control-sm tx-13"
              type="text"
              v-model.trim="logistics"
            />
          </div>
        </div>
        <div class="row form-group">
          <label class="wd-150 col-form-label form-control-sm text-right">
            {{ $t("express.区域设置：") }}<span class="tx-danger">*</span>
          </label>
          <div class="col-9 d-flex tx-gray-900 align-items-center">
            <div v-show="areaConfig.length" class="mg-r-30">
              <span
                v-for="(area, i) in areaConfig"
                :key="area.name + i"
                class="mg-r-20"
              >
                <a
                  href="javascript:;"
                  :class="area.active ? 'active' : ''"
                  class="area-btn mg-r-10"
                  @click="getAreaDetail(area)"
                  >{{ area.name }} ({{ getNum(area) }})</a
                >
                <a href="javascript:;" class="tx-danger" @click="remove(i)">{{
                  $t("express.删除")
                }}</a>
              </span>
            </div>
            <div class="d-flex align-items-center" style="align-self: center">
              <template v-if="addSelf">
                <input
                  :placeholder="$t('express.请输入区域名称')"
                  class="form-control form-control-sm tx-13 wd-150"
                  type="text"
                  v-model.trim="areaName"
                />
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-info mg-r-5 mg-l-10 tx-12"
                  @click="addSelfSave()"
                  >{{ $t("express.保存") }}</a
                >
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-secondary tx-12"
                  @click="addSelfCncel()"
                  >{{ $t("express.取消") }}</a
                >
              </template>
              <a v-else href="javascript:;" class="tx-info" @click="addSelfFn"
                ><i class="icon ion-android-add mg-r-5"></i
                >{{ $t("express.添加区域") }}</a
              >
            </div>
          </div>
        </div>
        <template v-for="(area, i) in areaConfig">
          <div :key="area.name + i" v-if="area.active">
            <div class="row form-group">
              <label class="wd-150 col-form-label form-control-sm text-right">
                {{ $t("express.支持国家：") }}<span class="tx-danger">*</span>
              </label>
              <div class="col-9">
                <div class="d-flex">
                  <div class="continents-nav">
                    <a
                      v-for="continent in area.countrys"
                      :key="continent.name"
                      href="javascript:;"
                      :class="{ active: continent.active }"
                      @click="changeContinent(continent, area)"
                    >
                      <label class="ckbox mg-b-0">
                        <input
                          type="checkbox"
                          :checked="checkedContinent(continent, area)"
                          @change="selectAllCountry($event, continent, area)"
                        />
                        <span></span>
                      </label>
                      {{ continent.name }}
                      <span v-if="checkedNum(continent, area)">
                        ({{ checkedNum(continent, area) }})
                      </span>
                    </a>
                  </div>
                  <div class="country-wrap">
                    <ul
                      v-for="continent in area.countrys"
                      :key="continent.name"
                      :class="{ active: continent.active }"
                      class="country-list"
                    >
                      <li
                        v-for="country in continent.sub"
                        :key="country.code2"
                        :class="{ active: country.checked }"
                      >
                        <label class="ckbox mg-b-0">
                          <input
                            :disabled="country.disabled"
                            type="checkbox"
                            v-model="country.checked"
                          />
                          <span>{{ country.nameCN }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptTargetType"
                class="wd-150 col-form-label form-control-sm text-right"
              >
                {{ $t("express.运费规则：") }}<span class="tx-danger">*</span>
              </label>
              <div class="col-md-9 col-sm-12">
                <div>
                  <div class="form-check form-check-inline mg-r-15">
                    <label class="rdiobox">
                      <input
                        type="radio"
                        name="ruleType"
                        value="1"
                        v-model="area.ruleType"
                      />
                      <span>{{ $t("express.按单收费") }}</span>
                    </label>
                  </div>
                  <div class="form-check form-check-inline mg-r-15">
                    <label class="rdiobox">
                      <input
                        type="radio"
                        name="ruleType"
                        value="2"
                        v-model="area.ruleType"
                      />
                      <span>{{ $t("express.按重量收费") }}</span>
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <label class="rdiobox">
                      <input
                        type="radio"
                        name="ruleType"
                        value="3"
                        v-model="area.ruleType"
                      />
                      <span>{{ $t("express.按件收费") }}</span>
                    </label>
                  </div>
                </div>
                <div v-if="area.ruleType == 1">
                  <span class="tx-gray-600 mg-r-5">{{
                    $t("express.每单")
                  }}</span>
                  <input
                    type="text"
                    class="
                      d-inline-block
                      form-control form-control-sm
                      tx-13
                      wd-100
                      mg-r-5
                    "
                    v-model="area.everyFee"
                  />
                  <span class="tx-gray-600">{{ $t("express.元") }}</span>
                </div>
                <div v-if="area.ruleType == 2">
                  <div
                    v-for="(rule, r) in area.ruleJsons"
                    :key="r"
                    class="pd-x-15 pd-y-10 bg-gray-300 mg-b-15"
                  >
                    <div class="d-flex align-items-center">
                      <p>
                        <input
                          type="text"
                          class="
                            d-inline-block
                            wd-100
                            mg-r-5
                            form-control form-control-sm
                            tx-13
                          "
                          v-model="rule.start"
                        />
                        <span class="tx-gray-600">{{ $t("express.克") }}</span>
                        ---
                        <input
                          type="text"
                          class="
                            d-inline-block
                            wd-100
                            mg-r-5
                            form-control form-control-sm
                            tx-13
                          "
                          v-model="rule.end"
                        />
                        <span class="tx-gray-600">{{ $t("express.克") }}</span>
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <p>
                        <span class="tx-gray-600 mg-r-5">{{
                          $t("express.首重")
                        }}</span>
                        <input
                          type="text"
                          class="
                            d-inline-block
                            wd-100
                            mg-r-5
                            form-control form-control-sm
                            tx-13
                          "
                          v-model="rule.startWeight"
                        />
                        <span class="tx-gray-600">{{ $t("express.克") }}</span
                        >，
                        <span class="tx-gray-600 mg-r-5">{{
                          $t("express.运费")
                        }}</span>
                        <input
                          type="text"
                          class="
                            d-inline-block
                            wd-100
                            mg-r-5
                            form-control form-control-sm
                            tx-13
                          "
                          v-model="rule.startPrice"
                        />
                        <span class="tx-gray-600">{{ $t("express.元") }}</span
                        >；
                      </p>
                      <p>
                        <span class="tx-gray-600 mg-r-5">{{
                          $t("express.续重每")
                        }}</span>
                        <input
                          type="text"
                          class="
                            d-inline-block
                            wd-100
                            mg-r-5
                            form-control form-control-sm
                            tx-13
                          "
                          v-model="rule.incWeight"
                        />
                        <span class="tx-gray-600">{{ $t("express.克") }}</span
                        >，
                        <span class="tx-gray-600 mg-r-5">{{
                          $t("express.运费增加")
                        }}</span>
                        <input
                          type="text"
                          class="
                            d-inline-block
                            wd-100
                            mg-r-5
                            form-control form-control-sm
                            tx-13
                          "
                          v-model="rule.incPrice"
                        />
                        <span class="tx-gray-600">{{ $t("express.元") }}</span>
                      </p>
                    </div>
                    <a
                      v-if="r > 0"
                      href="javascript:;"
                      class="tx-danger"
                      @click="removeRule(area, r)"
                      >{{ $t("express.删除") }}</a
                    >
                  </div>
                  <a href="javascript:;" class="tx-info" @click="addRule(area)"
                    ><i class="icon ion-android-add mg-r-5"></i
                    >{{ $t("express.再加一条") }}</a
                  >
                </div>
                <div v-if="area.ruleType == 3">
                  <p>
                    <span class="tx-gray-600">{{ $t("express.首件") }}</span>
                    <input
                      type="text"
                      class="
                        d-inline-block
                        wd-100
                        form-control form-control-sm
                        mg-x-5
                      "
                      v-model.number="area.startPrice"
                    />
                    <span class="tx-gray-600">{{ $t("express.元") }}</span>
                  </p>
                  <p>
                    <span class="tx-gray-600">{{
                      $t("express.后续每件")
                    }}</span>
                    <input
                      type="text"
                      class="
                        d-inline-block
                        wd-100
                        form-control form-control-sm
                        mg-x-5
                      "
                      v-model.number="area.incPrice"
                    />
                    <span class="tx-gray-600">{{ $t("express.元") }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="row form-group">
          <label class="wd-150 col-form-label form-control-sm text-right">
            {{ $t("express.体积重计算系数：") }}
          </label>
          <div class="col-4">
            <input
              class="form-control form-control-sm tx-13"
              type="text"
              v-model.trim="volumetricWeight"
            />
          </div>
        </div>
        <div class="row form-group">
          <label class="wd-150 col-form-label form-control-sm text-right">
            {{ $t("express.是否启用：") }}
          </label>
          <div class="col-9">
            <div class="form-check form-check-inline mg-r-15">
              <label class="rdiobox">
                <input type="radio" name="status" value="1" v-model="status" />
                <span>{{ $t("express.启用") }}</span>
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="rdiobox">
                <input type="radio" name="status" value="2" v-model="status" />
                <span>{{ $t("express.停用") }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-group mg-b-0">
          <div class="modal-footer justify-content-center">
            <button
              type="button"
              class="
                btn btn-info
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="save"
            >
              {{ $t("express.保存信息") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <api-loading :show="loading"></api-loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftSideStatus: true, //左边栏状态
      loading: false,
      logistics: "", //物流名称
      countrys: [],
      ruleType: 1,
      everyFee: "",
      startWeight: "",
      startPrice: "",
      incWeight: "",
      incPrice: "",
      priceFree: "",
      startPrice3: "",
      incPrice3: "",
      volumetricWeight: "", //体积重系数
      status: 1, //1启用 2停用
      addSelf: false,
      areaConfig: [],
      areaName: "",
      id: this.$route.query.logistics ? this.$route.query.logistics : "",
      info: "",
      disableCountry: [],
    };
  },
  components: {},
  computed: {},
  watch: {},
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  mounted() {
    this.getCountrys();
    if (this.id) this.getInfo();
  },
  methods: {
    showRuleJson(val) {
      if (!val) return;
      return JSON.parse(val);
    },
    getInfo() {
      $.api_call(
        "api.InterShipping.findBySupplier",
        {
          logistics: this.id,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            if (!r.Data.Results) return;
            this.info = r.Data.Results[0];
            this.logistics = this.info.logistics;
            this.status = this.info.status;
            this.volumetricWeight = this.info.volumetricWeight;
            let arr = [];
            this.info.areaConfig.forEach((e) => {
              arr.push({
                id: e.id,
                countryCodeStr: e.countryCodeStr,
                active: false,
                name: e.name,
                ruleType: e.ruleType,
                everyFee:
                  e.ruleJson && e.ruleType == 1
                    ? JSON.parse(e.ruleJson).everyFee
                    : "",
                ruleJsons:
                  e.ruleJson && e.ruleType == 2
                    ? JSON.parse(e.ruleJson)
                    : [
                        {
                          start: 1,
                          end: "",
                          startWeight: "",
                          startPrice: "",
                          incWeight: "",
                          incPrice: "",
                        },
                      ],
                startPrice:
                  e.ruleJson && e.ruleType == 3
                    ? JSON.parse(e.ruleJson).startPrice
                    : "",
                incPrice:
                  e.ruleJson && e.ruleType == 3
                    ? JSON.parse(e.ruleJson).incPrice
                    : "",
              });
            });
            this.areaConfig = arr;
            this.areaConfig.forEach((area) => {
              this.$set(
                area,
                "countrys",
                JSON.parse(JSON.stringify(this.countrys))
              );
              area.countrys.forEach((e) => {
                e.sub.forEach((c) => {
                  if (area.countryCodeStr.indexOf(c.code2) > -1) {
                    this.$set(c, "checked", true);
                  }
                });
              });
              area.countrys.forEach((e) => {
                e.active = false;
              });
              area.countrys.some((e) => {
                if (this.checkedNum(e)) {
                  e.active = true;
                  return true;
                }
              });
            });
            this.areaConfig[0].active = true;
            this.getAreaDetail(this.areaConfig[0]);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    remove(r) {
      this.areaConfig.splice(r, 1);
      ShowTip(this.$t("express.删除成功"), "success");
      if (this.areaConfig.length) {
        this.areaConfig[0].active = true;
        this.getAreaDetail(this.areaConfig[0]);
      }
    },
    removeRule(area, r) {
      area.ruleJsons.splice(r, 1);
      ShowTip(this.$t("express.删除成功"), "success");
    },
    addRule(area) {
      let arr = [];
      arr = area.ruleJsons;
      let obj = {
        start: 1,
        end: "",
        startWeight: "",
        startPrice: "",
        incWeight: "",
        incPrice: "",
      };
      arr.push(obj);
      this.$set(area, "ruleJsons", arr);
      ShowTip(this.$t("express.添加成功"), "success");
    },
    save() {
      let countryCode = [];
      let arr = [];
      this.areaConfig.forEach((area) => {
        this.setAreaCountry(area);
        //					area.countrys.forEach(e => {
        //						e.sub.forEach(sub => {
        //							if(sub.checked) {
        //								countryCode.push(sub.code2);
        //							}
        //						});
        //					});
        //					this.$set(area,"countryCodeStr",countryCode.join(","));
        arr.push({
          id: area.id ? area.id : "",
          name: area.name,
          countryCodeStr: area.countryCodeStr,
          ruleType: area.ruleType,
          everyFee: area.everyFee,
          ruleJsons: area.ruleJsons,
          startPrice: area.startPrice,
          incPrice: area.incPrice,
        });
      });
      //				console.log(arr)
      //				console.log(this.areaConfig)
      //				return;
      if (!this.logistics) {
        ShowTip(this.$t("express.请输入物流名称"), "danger");
        return;
      }

      this.loading = true;
      let param = {
        volumetricWeight: this.volumetricWeight,
        logistics: this.logistics,
        status: this.status,
        areaConfig: arr,
      };
      if (this.info) {
        param.id = this.info.id;
      }
      $.api_call("api.InterShipping.createUpdate", param, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          if (this.info) {
            ShowTip(this.$t("express.修改成功"), "success");
          } else {
            ShowTip(this.$t("express.添加成功"), "success");
          }
          setTimeout(() => {
            this.$router.push({ path: "/int-shippingfee" });
          }, 300);
          //						this.saveSuccess();
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getAreaDetail(item) {
      this.areaConfig.forEach((e) => {
        this.$set(e, "active", false);
        this.setAreaCountry(e);
      });
      this.$set(item, "active", true);
      this.setAreaCountry(item);
    },
    addSelfSave() {
      if (!this.areaName) {
        ShowTip(this.$t("express.请填写区域名称"), "danger");
        return;
      }
      this.areaConfig.push({
        countrys: JSON.parse(JSON.stringify(this.countrys)),
        countryCodeStr: "",
        active: false,
        name: this.areaName,
        ruleType: 1,
        everyFee: "",
        ruleJsons: [
          {
            start: 1,
            end: "",
            startWeight: "",
            startPrice: "",
            incWeight: "",
            incPrice: "",
          },
        ],
        startPrice: "",
        incPrice: "",
      });
      this.areaName = "";
      this.addSelf = false;
      ShowTip(this.$t("express.添加成功"), "success");
      if (this.areaConfig.length == 1) {
        this.areaConfig[0].active = true;
        this.getAreaDetail(this.areaConfig[0]);
      }
    },
    addSelfCncel() {
      this.addSelf = false;
    },
    addSelfFn() {
      this.addSelf = true;
    },
    checkedDisabled(item) {
      return this.disableCountry.includes(item.code2);
    },
    checkedNum(item, area) {
      let num = 0;
      item.sub.forEach((e) => {
        if (e.checked) {
          num++;
        }
      });
      return num;
    },
    checkedContinent(item, area) {
      //洲是否全选
      return item.sub.every((e) => {
        return e.checked;
      });
    },
    selectAllCountry(event, item, area) {
      item.sub.forEach((e) => {
        if (!e.disabled) {
          this.$set(e, "checked", event.target.checked);
        }
      });
      this.getNum(area);
    },
    changeContinent(item, area) {
      area.countrys.forEach((c) => {
        this.$set(c, "active", false);
      });
      this.$set(item, "active", true);

      this.getNum(area);
    },
    getNum(area) {
      let countryCode = [];
      area.countrys.forEach((e) => {
        e.sub.forEach((sub) => {
          if (sub.checked) {
            countryCode.push(sub.code2);
          }
        });
      });
      if (!countryCode.length) return 0;
      return countryCode.length;
    },
    setAreaCountry(area) {
      let countryCode = [];
      area.countrys.forEach((e) => {
        e.sub.forEach((sub) => {
          if (sub.checked) {
            countryCode.push(sub.code2);
          }
        });
      });

      if (countryCode.length) {
        this.$set(area, "countryCodeStr", countryCode.join(","));
      } else {
        this.$set(area, "countryCodeStr", "");
      }

      let disable = [];
      this.areaConfig.forEach((e) => {
        if (!e.active) {
          disable.push(e.countryCodeStr);
        }
      });
      this.disableCountry = [];
      if (disable.length) this.disableCountry = disable.join(",").split(",");
      area.countrys.forEach((e) => {
        e.sub.forEach((sub) => {
          this.$set(sub, "disabled", false);
          this.disableCountry.forEach((disable) => {
            if (sub.code2 == disable) {
              this.$set(sub, "disabled", true);
            }
          });
        });
      });
      this.getNum(area);
    },
    getCountrys() {
      // 获取国家
      $.api_call("api.InterShipping.getCountrys", {}, (r) => {
        if (r.ErrorCode == "9999") {
          this.countrys = [];
          let countrys = r.Data.Results.country;
          Object.keys(countrys).forEach((key) => {
            let sub = [];
            Object.keys(countrys[key]).forEach((k) => {
              countrys[key][k].checked = false;
              sub.push(countrys[key][k]);
            });
            this.countrys.push({
              name: key,
              checked: false,
              active: false,
              sub,
            });
            this.$set(this.countrys[0], "active", true);
          });
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.continents-nav {
  > a {
    display: flex;
    align-items: center;
    border: 1px #ddd solid;
    border-bottom: none;
    padding: 5px 15px;
    min-width: 125px;
  }
  > a:last-child {
    border-bottom: 1px #ddd solid;
  }
  > a.active {
    background-color: #17a2b8;
    color: #fff;
    border-right-color: #17a2b8;
  }
}

.country-wrap {
  padding: 5px 0;
  flex: 1;
  height: 192px;
  border: 1px #ddd solid;
  border-left: none;
  overflow-y: auto;
  .country-list {
    list-style: none;
    display: none;
    flex-wrap: wrap;
    margin: 0;
    padding: 0 15px;
    font-size: 12px;
    li {
      margin-right: 10px;
      margin-bottom: 3px;
      padding: 3px;
      border: 1px #ddd solid;
      user-select: none;
    }
    li.active {
      background-color: #eee;
      color: #333;
    }
  }
  .country-list.active {
    display: flex;
  }
}
.area-btn {
  padding: 3px 15px;
  border: 1px #ddd solid;
  border-radius: 3px;
  color: #333;
  background: #f3f3f3;
}
.area-btn.active {
  background-color: #17a2b8;
  border-color: #17a2b8;
  color: #fff;
}
</style>